import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {useUnreadGradedAssignmentsQuery} from '../queries/UnreadGradedAssignments.queries.generated';

/**
 * Unread released grades for the student — every one of them, whether or not the teacher left
 * written feedback. Scoped to the classroom the surrounding assignment list is scoped to: the
 * banner sits above that list, so listing another class's assignments there would act on rows
 * the student cannot see.
 */
export default function useReviewGradeBanner(classroomId?: string) {
  const {isFeatureEnabled, isLoading: isFeatureFlagLoading} =
    useIsFeatureFlagEnabled('frq_teacher_grading');

  const {data, loading, refetch} = useUnreadGradedAssignmentsQuery({
    variables: classroomId ? {classrooms: {id: {eq: classroomId}}} : {},
    skip: !isFeatureEnabled
  });

  // Re-filter what the server already filtered: marking one seen writes
  // `studentHasSeenEvaluation` onto the normalized entity, and re-reading the list here is what
  // drops that row immediately, without waiting on a refetch that a route change could outrun.
  const assignments = (data?.currentUser?.studentAssignments.results ?? []).filter(
    (assignment) => !assignment.studentHasSeenEvaluation
  );

  return {
    assignments,
    isEnabled: isFeatureEnabled,
    isLoading: isFeatureFlagLoading || loading,
    refetch
  };
}
